export default __webpack_public_path__ + "de33ba1e605ca47d584ac87f183afed9.svg";